import React, { useRef, useState } from "react";
import { Grid } from "@mui/material";
import { FormButton, SpinnerOverlay } from "components";
import { FormikSelectInput, FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { LARGO, mensajeLargo } from "consts/limites-campos";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { RNHTituloIns } from "services/services-mia/programa-salud/personal/RNHTituloIns";

export default function InsertModal({ updateList, closeModal }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);
    const formikRef = useRef();

    const handleCreateTitulo = async (values) => {
        const response = await RNHTituloIns(
            credentials,
            {
                name: values.nombre,
                cod: values.cod,
                matricula: values.matricula,
                wkt: values.wkt
            }
        );
        if (response.ok) {
            setSnackBarInfo({
                message: "Título creado correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            closeModal();
        }
    }
    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                nombre: "",
                cod: "",
                matricula: "",
            }}
            validationSchema={
                yup.object({
                    nombre: yup.string("Debe ingresar un nombre").max(LARGO.nombre, mensajeLargo(LARGO.nombre)).required("Debe ingresar un nombre"),
                    cod: yup.string("Debe ingresar un código").max(LARGO.cod, mensajeLargo(LARGO.cod)).required("Debe ingresar un código"),
                    matricula: yup.string().oneOf(["Y", "N"]).required("Debe indicar si requiere matrícula"),
                })
            }
            onSubmit={(values) => {
                handleCreateTitulo(values);
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                        <Grid
                          container
                          columns={5}
                          rowSpacing={0}
                          columnSpacing={2}
                          sx={{
                            width: "100%",
                            "& .MuiFormControl-root": { marginTop: 0, marginBottom: 0 },
                          }}
                        >
                          <Grid item xs={1}>
                            <FormikTextInput
                                fullWidth={true}
                                name="cod"
                                labelText="Código"
                                inputProps={{ maxLength: LARGO.cod }}
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <FormikTextInput
                                fullWidth={true}
                                name="nombre"
                                labelText="Nombre"
                                inputProps={{ maxLength: LARGO.nombre }}
                            />
                          </Grid>
                          <Grid item xs={1}>
                            <FormikSelectInput
                                fullWidth={true}
                                name="matricula"
                                labelText="Matrícula"
                            >
                                <option value="" disabled>
                                    Seleccione
                                </option>
                                <option value="Y">Sí</option>
                                <option value="N">No</option>
                            </FormikSelectInput>
                          </Grid>
                        </Grid>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Crear" }}
                        onCloseModal={closeModal}
                    />
                    {(inRequest) && <SpinnerOverlay />}
                </div>
            </Form>
        </Formik>
    );
}
